@if (ufFilterFacade.getUfs() && ufFilterFacade.getUfs().length > 0) {
  <div
    class="uf-filter-list"
    >
    <p class="label">
      Escolha a UF que deseja visualizar.
    </p>
    <div class="buttons-container">
      <ui-toggle-button
        (p-click)="clearFilters()"
        [p-is-selected]="(ufFilterFacade.observeSelectedUf() | async) === null"
        >
        Todas
      </ui-toggle-button>
      @for (uf of ufFilterFacade.getUfs(); track uf) {
        <ui-toggle-button
          [p-is-selected]="(ufFilterFacade.observeSelectedUf() | async)?.id === uf.id"
          (p-click)="filter(uf)"
          >
          {{uf.descricao}}
        </ui-toggle-button>
      }
    </div>
  </div>
}